/* eslint-disable */
import { produce } from "immer";
import {
  GUIDANCE_EXPLORER_CARD_FETCH_START,
  GUIDANCE_EXPLORER_CARD_SUCCESS,
  GUIDANCE_EXPLORER_CARD_FAILURE,
} from "../actions/types";

const guidanceExplorerCard = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case GUIDANCE_EXPLORER_CARD_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case GUIDANCE_EXPLORER_CARD_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case GUIDANCE_EXPLORER_CARD_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default guidanceExplorerCard;
